import { render, staticRenderFns } from "./Forgotpassword.vue?vue&type=template&id=1445e43c&scoped=true"
import script from "./Forgotpassword.vue?vue&type=script&lang=js"
export * from "./Forgotpassword.vue?vue&type=script&lang=js"
import style0 from "./Forgotpassword.vue?vue&type=style&index=0&id=1445e43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1445e43c",
  null
  
)

export default component.exports